import styles from "../styles/styles.module.css";
import SurveyDuration from "./SurveyDuration";
import SurveyPageList from "./SurveyPageList";

const SurveyNavigation = ({ surveyInfo, getSurveyInfoHandler, id, pathname }) => {
  return (
    <div className={styles["survey-navigation"]}>
      <SurveyPageList
        id={id}
        surveyInfo={surveyInfo}
        getSurveyInfoHandler={getSurveyInfoHandler}
        pathname={pathname}
      />
      <SurveyDuration
        surveyInfo={surveyInfo}
        getSurveyInfoHandler={getSurveyInfoHandler}
      />
    </div>
  );
};

export default SurveyNavigation;
